import { IInitialData } from "@proj-common/types"

let initialData: IInitialData = null

declare var IL_INITIAL_DATA: string

if (IL_INITIAL_DATA != '%IL_INITIAL_DATA%') {
    initialData = JSON.parse(IL_INITIAL_DATA)
}

export const InitialData = initialData